var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#39383A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(8 8)",
    fill: "#39383A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 25C27.859 25 30.999 21.86 30.999 18C30.999 14.14 27.859 11 23.999 11C20.139 11 16.999 14.14 16.999 18C16.999 21.86 20.139 25 23.999 25ZM23.999 13C26.7563 13 28.999 15.2427 28.999 18C28.999 20.7573 26.7563 23 23.999 23C21.2416 23 18.999 20.7573 18.999 18C18.999 15.2427 21.2416 13 23.999 13ZM34.3323 31.9561V33.304C34.3323 34.5507 33.8776 35.7453 33.051 36.6667C32.8537 36.888 32.5803 37 32.3056 37C32.0683 37 31.8296 36.9159 31.639 36.7453C31.227 36.3773 31.1936 35.7453 31.5616 35.3333C32.059 34.7773 32.3336 34.0573 32.3336 33.3053V31.9574C32.3336 29.9387 30.995 28.1919 29.0763 27.7106C28.739 27.6253 28.3763 27.672 28.0817 27.8387C25.547 29.2494 22.4456 29.2439 19.927 27.8426C19.6256 27.6706 19.263 27.6213 18.9257 27.7093C17.007 28.192 15.667 29.9387 15.667 31.9574V33.3053C15.667 34.0587 15.9417 34.7787 16.439 35.3333C16.807 35.7453 16.7723 36.3773 16.3616 36.7453C15.9483 37.1146 15.3163 37.0786 14.9497 36.668C14.123 35.7453 13.6683 34.5507 13.6683 33.3053V31.9574C13.6683 29.0214 15.6296 26.4773 18.4376 25.7707C19.2683 25.56 20.171 25.6801 20.9096 26.1014C22.8163 27.1627 25.179 27.1667 27.1017 26.0973C27.831 25.6813 28.7337 25.5626 29.567 25.772C32.371 26.4746 34.3323 29.0187 34.3323 31.9561Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.f5ef717e.svg";
export { ForwardRef as ReactComponent };